export const titleCodes = {
    
    contact: {
        code: "${merchantId}_tmpl_title_8",
        title: "Contact Us"
    },

    address: {
        code: "${merchantId}_tmpl_title_9",
        title: "Address:"
    },

    email: {
        code: "${merchantId}_tmpl_title_10",
        title: "Email:"
    },
}

export const textCodes = {
    
    address1: {
        code: "${merchantId}_tmpl_text_10",
        text: "Willow Label Company Limited"
    },

    address2: {
        code: "${merchantId}_tmpl_text_11",
        text: "Hlaing Township Yangon, Myanmar"
    },

    emailText: {
        code: "${merchantId}_tmpl_text_12",
        text: "willowclothingmm@gmail.com"
    },

}
